import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function CreditsModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;

    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="credits-root">
      <button className="credits-close" onClick={onClose} title="Chiudi">
        <X size={26} />
      </button>

      <div className="stars"></div>
      <div className="fade"></div>

      <section className="crawl-container">
        <div className="crawl-content">
          <h2>EPISODIO I</h2>
          <h1>IL RISVEGLIO DEI TAVOLI</h1>

          <p>
            E' un periodo di fermento ludico. Mentre le armate del caos tentano
            di occupare ogni superficie piana disponibile, una nuova speranza
            sorge per i giocatori della galassia.
          </p>

          <p>
            Dalle nebbie delle CRONACHE DALLA BIBLIOTECA e dalle gloriose terre
            dei PATROGAMES, e' emersa un'antica tecnologia, un artefatto digitale
            capace di riportare l'ordine tra i tavoli e i meeple.
          </p>

          <p>
            Grazie a questa App, i valorosi eroi non dovranno piu' temere di
            restare senza una sedia mentre il destino del mondo viene deciso da
            un tiro di dado. La pace regna sovrana, ora che ogni posto e'
            assicurato dai Guardiani del Codice...
          </p>

          <div className="credits">
            <p>PRODOTTO DA: Oreste</p>
            <p>CO-PRODUZIONE: Raffaele</p>
            <p>DISTRIBUZIONE: Il Rampollo dei Bostrazzi</p>
            <p>
              UN GRAZIE SPECIALE AI MAGNIFICI BETA TESTER E PROMOTORI DI IDEE:
              <br />
              Alessia
              <br />
              Chiara
              <br />
              Giorgio
              <br />
              Marco
              <br />
              Nicolo'
              <br />
              Paolo
              <br />
              Sandro
            </p>
          </div>

          <p>Che la forza (e un buon tiro di iniziativa) sia sempre con voi!</p>
        </div>
      </section>

      <style>{`
        .credits-root {
          position: fixed;
          inset: 0;
          z-index: 9999;
          width: 100%;
          height: 100%;
          background: #000;
          overflow: hidden;
          margin: 0;
        }

        .credits-close {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 10000;
          width: 46px;
          height: 46px;
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,0.25);
          background: rgba(0,0,0,0.45);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .credits-close:hover {
          background: rgba(255,255,255,0.16);
        }

        .stars {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url('https://www.transparenttextures.com/patterns/stardust.png');
          z-index: 0;
        }

        .fade {
          position: relative;
          width: 100%;
          min-height: 60vh;
          top: -25px;
          background-image: linear-gradient(0deg, transparent, black 75%);
          z-index: 1;
        }

        .crawl-container {
          display: flex;
          justify-content: center;
          position: relative;
          height: 800px;
          color: #feda4a;
          font-family: 'News Gothic', sans-serif;
          font-size: clamp(28px, 8vw, 80px);
          font-weight: 600;
          letter-spacing: 6px;
          line-height: 150%;
          perspective: 400px;
          text-align: justify;
          z-index: 2;
        }

        .crawl-content {
          position: relative;
          top: 9999px;
          transform-origin: 50% 100%;
          animation: crawl 70s linear infinite;
        }

        .crawl-content h1 {
          font-size: 90%;
          text-align: center;
          margin-bottom: 50px;
        }

        .crawl-content h2 {
          text-align: center;
          margin-bottom: 50px;
        }

        @keyframes crawl {
          0% {
            top: 0;
            transform: rotateX(24deg) translateZ(0);
          }
          100% {
            top: -6000px;
            transform: rotateX(25deg) translateZ(-2500px);
          }
        }

        .credits {
          text-align: center;
          margin-top: 100px;
          font-size: 0.7em;
        }
}
      `}</style>
    </div>
  );
}